import { memo, MouseEvent } from 'react';
import clsx from 'clsx';
import { ProductImage } from 'src/modules/common/components/ProductImage/ProductImage.tsx';
import { CheckboxButton } from 'src/modules/common/components/Checkbox/CheckboxButton';

type Props = {
    title: string;
    checked: boolean;
    disabled: boolean;
    isSingleVariant: boolean;
    onChange: (e: MouseEvent<HTMLButtonElement>) => void;
    imageURL: string;
    name: string;
}

export const HomeValve = memo(({ name, title, disabled, isSingleVariant, checked, onChange, imageURL }: Props) => (
    <button
        type="button"
        className={clsx({
            'vss-home-valve': true,
            'vss-checkbox-wrapper': true,
            'vss-home-valve--disabled': disabled,
            'vss-home-valve--single-variant': isSingleVariant,
        })}
        onClick={disabled ? () => null : onChange}
    >
        <div className="vss-home-valve__header">
            <h2 className="vss-home-valve__title">
                {title}
            </h2>

            <CheckboxButton id={`vss-valve-home-${name}`} checked={checked} disabled={disabled} onChange={() => null}/>
        </div>

        <div className="vss-home-valve__image">
            <ProductImage imgSrc={imageURL} imgAlt={title}/>
        </div>
    </button>
));
